import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-header border-0" }
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "px-7 py-5" }
const _hoisted_9 = { class: "row mb-8" }
const _hoisted_10 = { class: "col-lg-3 col-6" }
const _hoisted_11 = { class: "form-label fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-3 col-6" }
const _hoisted_13 = { class: "form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-3 col-6 mt-lg-0 mt-4" }
const _hoisted_15 = { class: "form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-3 col-6 mt-lg-0 mt-4" }
const _hoisted_17 = { class: "form-label fw-bold fs-6" }
const _hoisted_18 = ["label"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "card-footer d-flex justify-content-between align-items-center py-6 px-9" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "fw-bold fs-6 text-gray-700" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = {
  type: "submit",
  id: "kt_active_ads_summary_report_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_28 = { class: "indicator-label" }
const _hoisted_29 = { class: "indicator-progress" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_32 = { class: "card-body text-center py-12" }
const _hoisted_33 = { class: "svg-icon svg-icon-3x svg-icon-gray-400 mb-4 d-block" }
const _hoisted_34 = { class: "fs-4 fw-semibold text-gray-500" }
const _hoisted_35 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_36 = { class: "card-header border-0 d-flex justify-content-between align-items-center" }
const _hoisted_37 = { class: "card-title m-0" }
const _hoisted_38 = { class: "fw-bolder m-0" }
const _hoisted_39 = { class: "fs-7 text-muted ms-2" }
const _hoisted_40 = { class: "card-toolbar" }
const _hoisted_41 = {
  type: "button",
  class: "btn btn-light-primary btn-sm"
}
const _hoisted_42 = { class: "svg-icon svg-icon-2" }
const _hoisted_43 = { class: "card-body p-0" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 mb-0" }
const _hoisted_46 = { class: "bg-light" }
const _hoisted_47 = { class: "fw-bolder text-muted fs-7" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", { class: "ps-4 min-w-40px" }, "#", -1)
const _hoisted_49 = { class: "min-w-150px" }
const _hoisted_50 = { class: "min-w-100px" }
const _hoisted_51 = { class: "min-w-90px text-end" }
const _hoisted_52 = { class: "min-w-110px text-end" }
const _hoisted_53 = { class: "min-w-110px text-end pe-4" }
const _hoisted_54 = { class: "ps-4 text-gray-600" }
const _hoisted_55 = { class: "fw-semibold" }
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = { class: "text-end pe-4" }
const _hoisted_59 = { class: "bg-light" }
const _hoisted_60 = { class: "fw-bolder fs-7" }
const _hoisted_61 = {
  class: "ps-4",
  colspan: "3"
}
const _hoisted_62 = { class: "text-end" }
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { class: "text-end pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.translate('activeAdsSummaryReport')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('dateFrom')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.selectedItems.dateFrom]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('dateTo')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.selectedItems.dateTo]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.translate('area')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.areaId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.areaId) = $event)),
                          required: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.areas,
                          placeholder: _ctx.translate('selectArea'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('adType')), 1),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-select-sm form-select-solid",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.categoryId) = $event))
                        }, [
                          _createElementVNode("option", {
                            label: _ctx.translate('selectAdTypes'),
                            value: ""
                          }, null, 8, _hoisted_18),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (adType) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: adType.id,
                              value: adType.id
                            }, _toDisplayString(adType.titleAr), 9, _hoisted_19))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedItems.categoryId]
                        ])
                      ])
                    ]),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('NumOfData')) + ": " + _toDisplayString(_ctx.reportRows.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light-danger btn-sm me-3",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                    }, _toDisplayString(_ctx.translate('resetFilters')), 1),
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('back')), 1),
                    _createElementVNode("button", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translate('query')), 1),
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_30
                      ])
                    ], 512)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ]),
        (_ctx.hasQueried && !_ctx.isLoading && _ctx.reportRows.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate('noDataFound')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.reportRows.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h3", _hoisted_38, [
                    _createTextVNode(_toDisplayString(_ctx.translate('resultsPreview')) + " ", 1),
                    _createElementVNode("span", _hoisted_39, " (" + _toDisplayString(_ctx.reportRows.length) + ") ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_vue3_json_excel, {
                    "json-data": _ctx.reportRows,
                    fields: _ctx.excelHeader,
                    header: _ctx.excelHeaderRows,
                    worksheet: "Active Ads Summary WorkSheet",
                    name: 
              'Active_Ads_Summary_Report_' +
              new Date().toISOString().slice(0, 10) +
              '.xls'
            
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil017.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["json-data", "fields", "header", "name"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("table", _hoisted_45, [
                    _createElementVNode("thead", _hoisted_46, [
                      _createElementVNode("tr", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.translate('propertyType')), 1),
                        _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.translate('adType')), 1),
                        _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.translate('numberOfAds')), 1),
                        _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.translate('minPrice')), 1),
                        _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.translate('maxPrice')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportRows, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_54, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_55, _toDisplayString(item.title || '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.categoryName), 1),
                          _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.formatNumber(item.count)), 1),
                          _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.formatNumber(item.minPrice)), 1),
                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.formatNumber(item.maxPrice)), 1)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", _hoisted_59, [
                      _createElementVNode("tr", _hoisted_60, [
                        _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.translate('total')), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.formatNumber(_ctx.totals.count)), 1),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.formatNumber(_ctx.totals.minPrice)), 1),
                        _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.formatNumber(_ctx.totals.maxPrice)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}